module.exports = __webpack_public_path__ + "static/media/bg_2.f4b43ff8.jpg";